import { useQuery } from "@tanstack/react-query";
import { getAtkomstTeamsEditorStores } from "@coworker/app/src/hooks/API/core.service";
import { Store } from "../../shared/types/store";

/**
 * Returns only the Atkomst stores where the logged-in user has the
 * fixa.teams-editor permission (SUPERUSER role).
 *
 * Uses a single GET /atkomst/teams-editor-stores call which fetches
 * /nodes?includePermissions=true from Atkomst and filters server-side —
 * replacing the previous N × /authorize approach.
 *
 * Used to restrict the store switcher in Team Management so that
 * COWORKER-only stores are not listed.
 */
export const useAtkomstTeamsEditorStores = (enabled: boolean) =>
  useQuery<Store[]>({
    queryKey: ["atkomstTeamsEditorStores"],
    queryFn: () => getAtkomstTeamsEditorStores(),
    enabled,
    staleTime: 60 * 60 * 1000, // 1 hour
    retry: false,
  });
